import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage/session';
import qs from 'query-string';
const location = window.location.search;

let query = qs.parse(location);
const lang = query.lang;

var initState = {
  mode: lang ? lang : 'en',
  welcome_content: {
    title: 'WEB',
    desc: 'Hello, Web',
  },
  selected_content: 1,
  contents: [
    { id: 1, title: 'HTML', desc: 'HTML content...' },
    { id: 2, title: 'css', desc: 'css content...' },
    { id: 3, title: 'js', desc: 'js content...' },
  ],
};

const persistConfig = {
  key: 'root',
  storage: storage,
};

function reducer(state = initState, action) {
  if (action.type === 'CHANGE_MODE') {
    return { ...state, mode: action.mode };
  }
  return state;
}

export default persistReducer(persistConfig, reducer);
